{
  "save": "保存",
  "cancel": "キャンセル",
  "delete": "削除",
  "close": "閉じる",
  "edit": "編集",
  "update": "更新",
  "register": "登録",
  "back": "戻る",
  "loading": "読み込み中",
  "noData": "データがありません"
}
